module.exports = __webpack_public_path__ + "img/CV.Utilities.Chambers.Stakka_Quad_Chamber.a371b77e.png";